import { render, staticRenderFns } from "./MatTypeEditor.vue?vue&type=template&id=f1391a28&"
import script from "./MatTypeEditor.vue?vue&type=script&lang=js&"
export * from "./MatTypeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCombobox,VForm,VSkeletonLoader,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Lang\\pCloudSync\\mats\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1391a28')) {
      api.createRecord('f1391a28', component.options)
    } else {
      api.reload('f1391a28', component.options)
    }
    module.hot.accept("./MatTypeEditor.vue?vue&type=template&id=f1391a28&", function () {
      api.rerender('f1391a28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/MatTypeEditor.vue"
export default component.exports